import { ExtendedStyleProps } from '@assetron/common/types/extended';
import getColors from '@assetron/common/utils/getColors';
import getShadow from '@assetron/common/utils/getShadow';
import { alpha, Theme } from '@mui/material/styles';

function getColorStyle({ color, theme }: ExtendedStyleProps) {
  const colors = getColors(theme, color);
  const { main, dark, contrastText } = colors;

  const buttonShadow = `${color}Button`;
  const shadows = getShadow(theme, buttonShadow);

  return {
    color: contrastText,
    backgroundColor: main,
    boxShadow: shadows,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: dark,
    },
    '&:focus-visible': {
      outline: `2px solid ${dark}`,
      outlineOffset: 2,
    },
    '&::after': {
      boxShadow: `0 0 5px 5px ${alpha(main, 0.9)}`,
      content: '""',
      display: 'block',
      position: 'absolute',
      left: '0',
      top: '0',
      width: 'calc(100%)',
      height: 'calc(100%)',
      opacity: 0,
      transition: 'all 0.5s',
    },
    '&:active::after': {
      boxShadow: `0 0 0 0 ${alpha(main, 0.9)}`,
      opacity: 1,
      transition: '0s',
    },
  };
}

export default function Fab(theme: Theme) {
  return {
    MuiFab: {
      styleOverrides: {
        root: {
          fontWeight: 400,
          '&.Mui-disabled': {
            backgroundColor: theme.palette.grey[100],
          },
          '&.MuiFab-primary': getColorStyle({ color: 'primary', theme }),
          '&.MuiFab-secondary': getColorStyle({ color: 'secondary', theme }),
          '&.Mui-error': getColorStyle({ color: 'error', theme }),
          '&.MuiFab-success': getColorStyle({ color: 'success', theme }),
          '&.MuiFab-info': getColorStyle({ color: 'info', theme }),
          '&.MuiFab-warning': getColorStyle({ color: 'warning', theme }),
        },
      },
    },
  };
}
